/* eslint-disable no-plusplus */
import React, { useState } from 'react';
import {
	Button,
	Popover,
	makeStyles
} from '@material-ui/core';

import TranslationHelper from '../../../../../common/TranslationHelper';
import UIHelper from '../../../../../common/UIHelper';

export default function ProductAttributesFilter(props) {
	const displayDefaultFilterAttribute = (attribute, actualIndex) => {
		const {
			currency,
			filterValues,
			filterAttributes,
			displayAttribute,
			handleFilterClick,
			customAttributeMap,
			allButtonsWidth
		} = props;
		const {
			uniqueName, name, attributeType
		} = attribute;
		const [anchorEl, setAnchorEl] = useState(null);
		const key = customAttributeMap.get(uniqueName) ? customAttributeMap.get(uniqueName) : uniqueName;
		let buttonLabel = name;

		const useStyles = makeStyles({
			label: {
				whiteSpace: 'nowrap',
				textOverflow: 'ellipsis',
				overflow: 'hidden',
				display: 'block'
			},
			root: {
				margin: '0 5px',
				outline: '0 !important',
				padding: '5px 8px',
				maxWidth: allButtonsWidth && allButtonsWidth[actualIndex] + 50,
				display: 'flex'
			}
		});

		const classes = useStyles();

		const handleClick = (event) => {
			setAnchorEl(event.currentTarget);
		};

		const handleClose = () => {
			setAnchorEl(null);
		};

		// eslint-disable-next-line default-case
		switch (buttonLabel) {
		case 'Category':
			buttonLabel = TranslationHelper.getValue('productattributes.category.label');
			break;
		case 'Unit Of Price':
			buttonLabel = TranslationHelper.getValue('productattributes.unitOfPrice.label');
			break;
		case 'Price':
			buttonLabel = TranslationHelper.getValue('productattributes.price.label');
			break;
		}

		if (filterAttributes[key]) {
			if (attributeType === 'Multi_Picklist') {
				buttonLabel = '';
				if (filterAttributes[key] && filterAttributes[key].searchValue) {
					buttonLabel += filterAttributes[key]
						.searchValue.map((selectedObj) => ` ${selectedObj.label}`);
				} else {
					buttonLabel += filterAttributes[key].map((selectedObj) => selectedObj.label);
				}
			} else if (attributeType === 'Picklist') {
				buttonLabel = filterAttributes[key];
			}
		}

		if (filterValues[`${uniqueName}filterValue`]) {
			if (attributeType === 'Currency') {
				buttonLabel = `${UIHelper.currencyFormatter(currency || 'cad')
					.format(filterValues[`${uniqueName}filterValue`][0])} - 
				${UIHelper.currencyFormatter(currency || 'cad').format(filterValues[`${uniqueName}filterValue`][1])}`;
			} else {
				buttonLabel = `${filterValues[`${uniqueName}filterValue`][0]} 
                - ${filterValues[`${uniqueName}filterValue`][1]}`;
			}
		}

		return (
			<div key={actualIndex}>
				<Popover
					open={Boolean(anchorEl)}
					anchorEl={anchorEl}
					onClose={handleClose}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					disableScrollLock
				>
					<p className="text-center" style={{ margin: '10px 10px 5px 10px' }}>{name}</p>
					<div style={{
						padding: '0px 10px 10px 10px',
						minWidth: '250px'
					}}
					>
						{displayAttribute(attribute, handleClose)}
					</div>
				</Popover>
				<Button
					variant="outlined"
					color={filterAttributes[key] || filterValues[`${uniqueName}filterValue`] ? 'secondary' : 'primary'}
					classes={{ label: classes.label, root: classes.root }}
					size="small"
					onClick={(e) => { handleFilterClick(e); handleClick(e); }}
					data-cy={buttonLabel}
				>
					{buttonLabel}
				</Button>
			</div>
		);
	};

	const {
		productAttributes,
		setCustomAttributeMap,
	} = props;

	const finalDiv = [];
	let actualIndex = -1;
	if (productAttributes && productAttributes.standardAttributes && productAttributes.standardAttributes.length) {
		finalDiv.push(productAttributes.standardAttributes.map((attribute) => (
			attribute.isFiltered
            && attribute.uniqueName !== 'location'
            && !(attribute.name === 'Category'
            && attribute.pickListElements
            && !attribute.pickListElements.length)
				? displayDefaultFilterAttribute(attribute, ++actualIndex)
				: null
		)));
	}

	if (productAttributes && productAttributes.customAttributes && productAttributes.customAttributes.length) {
		setCustomAttributeMap();
		const customAttr = (productAttributes.customAttributes.map((customAttribute) => {
			setCustomAttributeMap(customAttribute);

			return customAttribute.isFiltered ? displayDefaultFilterAttribute(customAttribute, ++actualIndex) : null;
		}));

		finalDiv.push(customAttr);
	}

	return finalDiv;
}
